import React from "react";

function Avatar({name}) {
  let namearr;
  if (name) {
    namearr = name?.split(" ");
  }
  return <div className="flex items-center justify-center w-7 h-7 rounded-full bg-slate-300 p-4">
    {
      namearr?.length === 2 && <h5 className="text-sm uppercase text-base">{`${namearr[0][0]}${namearr[1][0]}`}</h5>
    }
  </div>;
}

export default Avatar;
